import { render } from "./Register.vue?vue&type=template&id=50db4399&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=50db4399&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50db4399"],['__file',"src/views/public/newAccount/Register.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "50db4399"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('50db4399', __exports__)) {
    api.reload('50db4399', __exports__)
  }
  
  module.hot.accept("./Register.vue?vue&type=template&id=50db4399&scoped=true", () => {
    api.rerender('50db4399', render)
  })

}


export default __exports__